var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRestapiStandard = function SvgRestapiStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#fabc3c",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.225 19.396a1.003 1.003 0 000-1.414l-1.414-1.414-1.415 1.414 1.415 1.414a1.003 1.003 0 001.414 0zm-2.829 1.415l-1.414-1.415-1.414 1.415 1.414 1.414a1 1 0 001.414-1.414zm-3.535-7.778l-1.414-1.415-2.829 2.829 1.415 1.414a2.006 2.006 0 000 2.828l2.12 2.122 5.658-5.657-2.122-2.121a2.006 2.006 0 00-2.828 0zm11.107 11.106l1.414 1.414-2.829 2.829-1.414-1.415a2.006 2.006 0 01-2.828 0l-2.122-2.12 5.657-5.658 2.122 2.122a2.006 2.006 0 010 2.828z",
    fill: "#fabc3c"
  })));
};
export default SvgRestapiStandard;